<div id="print-container" class="print-layout">
  <div class="print-title">
    <app-logo [logoSize]="options.logoSize"></app-logo>
    <app-print-title
      [title]="options.title"
      [titleSize]="options.titleSize"></app-print-title>
    <app-device-description [deviceSize]="options.deviceSize"></app-device-description>
  </div>

  <div class="print-body">
    <app-simple-blank
      [fontSize]="options.fontSize"
      [lineHeight]="options.lineHeight"
      [borderValue]="options.borderInValues"
      [strongTitles]="options.strongTitles"
      [showEmptyRows]="options.showEmptyRows"
    ></app-simple-blank>
  </div>

  <div class="print-actions" *ngIf="showActions">
    <app-print-actions
      [options]="options"
      (print)="printCurrentBlank()"
      (backAndAdd)="navigateBackAndAdd()"
      (backAndEdit)="navigateBackAndEdit()"
      (optionsUpdate)="onOptionsUpdate($event)"
    ></app-print-actions>
  </div>
</div>
